import { render } from "./section-3.vue?vue&type=template&id=042e2481&scoped=true"
const script = {}

import "./section-3.vue?vue&type=style&index=0&id=042e2481&scoped=true&lang=scss"

import exportComponent from "/Users/macmini/builds/VJ28wZh6J/0/terracycle/tc-mini-site-frontend/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.69.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042e2481"]])

export default __exports__